import { render, staticRenderFns } from "./TempSignature.vue?vue&type=template&id=8c4434e2&scoped=true"
import script from "./TempSignature.vue?vue&type=script&lang=js"
export * from "./TempSignature.vue?vue&type=script&lang=js"
import style0 from "./TempSignature.vue?vue&type=style&index=0&id=8c4434e2&prod&lang=css"
import style1 from "./TempSignature.vue?vue&type=style&index=1&id=8c4434e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4434e2",
  null
  
)

export default component.exports